import { createFileRoute } from '@tanstack/react-router'

import { ItemMasterFormPage } from '@/features/inventory/components/item-master-form-page'

export const Route = createFileRoute('/_app/inventory/master/create')({
  loader: () => ({
    crumb: 'Tambah Bahan Baku',
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return <ItemMasterFormPage mode='create' />
}
